<template>
    <mini-table ref="_miniTable" read-only
                enable-inline-edit
                :items="enumList"
                :fields="tableFields"
                :loading="queryLoading"
                no-require-warning
                filterable>
        <template #rightHeader>
            <mini-button :loading="queryLoading" @btnClick="getEnumData">
                <i class="fa-solid fa-rotate-right"></i>
            </mini-button>
            <mini-button :loading="saveLoading" @btnClick="doSave">
                保存
            </mini-button>
        </template>
    </mini-table>
</template>

<script>
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

const ENTITY = 'emDictData';

export default {
    name: "DictionaryEnumEdit",
    mixins: [emCommonUtilMixin],
    components: {MiniButton, MiniTable},
    props: {
        nameLabel: {
            type: String,
            default: 'Name'
        },
        code: String,
        group: String,
        withLabel: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            enumList: [],
            queryLoading: false,
            saveLoading: false,
        }
    },
    computed: {
        tableFields() {
            let list = [
                {key: 'name', label: this.nameLabel, require: true},
                {key: 'value', label: 'Value'},
                {key: 'seq', label: 'Seq'},
                {key: 'remark', label: 'Remark'},
            ];
            if (this.withLabel) {
                list.splice(1, 0, {
                    key: 'value', label: 'Value'
                })
            }
            return list;
        },
        theUrl() {
            if (this.group) {
                return `${this._baseUrl(ENTITY)}simple/group/${this.group}`;
            } else {
                return `${this._baseUrl(ENTITY)}simple/${this.code}`;
            }
        },
    },
    watch: {
        code() {
            this.getEnumData();
        },
    },
    mounted() {
        this.getEnumData();
    },
    methods: {
        getEnumData() {
            if (this.code) {
                this.queryLoading = true;
                this.$store.dispatch('api/get', {
                    url: `${this.theUrl}/query` + this.urlParam()
                }).then(res => {
                    this.enumList = res;
                }).finally(() => this.queryLoading = false);
            }
        },
        doSave() {
            let obj = this.$refs._miniTable.collectInlineEditData();
            if (this.code) {
                if (obj.deleteIds && obj.deleteIds.length > 0 || obj.editRows && obj.editRows.length > 0) {
                    if (obj.editRows && obj.editRows.length > 0 && !this.$refs._miniTable.isInputCompete()) {
                        this.$message.warning(this.nameLabel + "不能为空")
                        return;
                    }
                    this.saveLoading = true;
                    this.$store.dispatch('api/post', {
                        url: `${this.theUrl}/edit` + this.urlParam(),
                        data: obj
                    }).then(() => {
                        this.$message.success("保存成功");
                        this.getEnumData();
                    }).finally(() => this.saveLoading = false);
                } else {
                    this.$message.warning("没有修改需要保存");
                }
            }
        },
        urlParam() {
            return this.group ? '?code=' + this.code : '';
        },
    }
}
</script>

<style scoped>

</style>
